import { render, staticRenderFns } from "./SecurityComponent.vue?vue&type=template&id=1c902c4e&scoped=true&"
import script from "./SecurityComponent.vue?vue&type=script&lang=js&"
export * from "./SecurityComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c902c4e",
  null
  
)

export default component.exports